import React from 'react'

const HNTranslationContext = React.createContext<any>({})
export default HNTranslationContext
